/* eslint-disable @angular-eslint/component-selector */
import type { OnChanges, AfterViewInit, SimpleChanges } from '@angular/core';
import { Component, EventEmitter, Input, Output, ViewEncapsulation, inject } from '@angular/core';
import type { IMyCalendarMonth } from '../../interfaces/my-calendar-month.interface';
import type { IMyOptions } from '../../interfaces/my-options.interface';
import { KeyCode } from '../../enums/key-code.enum';
import { ActiveView } from '../../enums/active-view.enum';
import { UtilService } from '../../services/angular-mydatepicker.util.service';
import { OPTS, MONTHS } from '../../constants/constants';

@Component({
  standalone: false,
  selector: 'lib-month-view',
  templateUrl: './month-view.component.html',
  providers: [UtilService],
  encapsulation: ViewEncapsulation.None,
})
export class MonthViewComponent implements OnChanges, AfterViewInit {
  private utilService = inject(UtilService);

  @Input() opts: IMyOptions;
  @Input() months: Array<Array<IMyCalendarMonth>>;
  @Input() viewChanged: boolean;

  @Output() monthCellClicked: EventEmitter<IMyCalendarMonth> = new EventEmitter<IMyCalendarMonth>();
  @Output() monthCellKeyDown: EventEmitter<any> = new EventEmitter<any>();
  @Output() viewActivated: EventEmitter<ActiveView> = new EventEmitter<ActiveView>();

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.hasOwnProperty(OPTS)) {
      this.opts = changes[OPTS].currentValue;
    }
    if (changes.hasOwnProperty(MONTHS)) {
      this.months = changes[MONTHS].currentValue;
    }
  }

  ngAfterViewInit(): void {
    this.viewActivated.emit(ActiveView.Month);
  }

  onMonthCellClicked(event: any, cell: IMyCalendarMonth): void {
    event.stopPropagation();

    if (cell.disabled) {
      return;
    }

    this.monthCellClicked.emit(cell);
  }

  onMonthCellKeyDown(event: any, cell: IMyCalendarMonth) {
    const keyCode: number = this.utilService.getKeyCodeFromEvent(event);
    if (keyCode !== KeyCode.tab) {
      event.preventDefault();

      if (keyCode === KeyCode.enter || keyCode === KeyCode.space) {
        this.onMonthCellClicked(event, cell);
      } else if (this.opts.moveFocusByArrowKeys) {
        this.monthCellKeyDown.emit(event);
      }
    }
  }
}
